import BillingCycle from  '../Rate/BillingCycleEnum'

export function createDefaultSubTenantRate(overrides = {}) {
  return {
    tenantDTO: {
      id: 0,
    },
    billingCycle: BillingCycle.MONTHLY,
    agreedRate: 0,
    subTenantList: [],
    agreedDate: new Date().toISOString().split("T")[0],
    tenantRate:0,
    active: true,
    ...overrides,
  };
}
